/**
 * Status Messages Utility
 *
 * Generates progressive status messages during AI summary generation.
 * Provides user feedback on processing progress.
 */

/**
 * Get status message based on elapsed time
 * Messages progress from initial analysis to finalization
 */
export function getStatusMessage(elapsedSeconds: number): string {
  if (elapsedSeconds >= 8) {
    return "Finalizing insights and recommendations...";
  }
  if (elapsedSeconds >= 5) {
    return "Analyzing notes and progress patterns...";
  }
  if (elapsedSeconds >= 3) {
    return "Processing task context and details...";
  }
  if (elapsedSeconds >= 1) {
    return "AI is analyzing task information...";
  }
  return "Analyzing task details...";
}

/**
 * Calculate elapsed time in seconds
 */
export function getElapsedSeconds(startTime: number): number {
  return Math.floor((Date.now() - startTime) / 1000);
}

/**
 * Get initial status message
 */
export function getInitialStatusMessage(): string {
  return "Analyzing task details...";
}

/**
 * Check if generation is in progress
 */
export function isGenerationInProgress(isLoading: boolean, isStreaming: boolean): boolean {
  return isLoading || isStreaming;
}
